import React from "react";
import AutoTyping, { BlinkCursor } from "react-auto-typing";
import { Link } from "react-router-dom";

const OurApproach = () => {
  const scrollHeader = () => {
    window.scroll({ top: 0, behavior: "instant" });
  };
  return (
    <div className="bfr-approach-wrapper">
      <div className="section-title">
        <h1 className="title">Key Features</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Features"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row m-0 mt-4 justify-content-between approach-container">
        <div className="col-12 col-lg-9">
          <div className="row gap-4">
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>1</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Biometric Access Control</h4>
                <p>
                  Fingerprint, retina, or facial recognition for enhanced
                  security.
                </p>
              </div>
            </div>
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>2</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Time & Attendance Tracking</h4>
                <p>
                  Automate employee attendance management with secure biometric
                  solutions.
                </p>
              </div>
            </div>
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>3</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Visitor Management</h4>
                <p>
                  We customize ERP modules for specialized tasks like supply
                  chain management, financial reporting, and inventory tracking.
                </p>
              </div>
            </div>
            <div className="col-12  module-item">
              <div className="title">
                <div>
                  0<span>4</span>
                </div>
              </div>
              <div className="flex-grow-1 description">
                <h4>Multi-Layered Security</h4>
                <p>
                  Combine biometric data with traditional security protocols for
                  an extra layer of protection.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3 mt-3 my-lg-4 align-items-start d-flex ">
          <div class="bfr-request-demo-wrapper">
            <p class="text-center">
              Schedule a personalized demo that addresses your unique business
              requirements.
            </p>
            <Link
              class=" btn py-2 px-4 mt-2"
              to="/contact-us"
              onClick={scrollHeader}
            >
              Request Demo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApproach;
